import { api } from "../../http";
import { store } from '../../store/store'

async function PostImagesRRIM(rrim,data) {
  try {
    
    const rrimImages = await api.post(`/rrim/images/${rrim}`, data, {
      onUploadProgress: async (event) => {
        let progress = Math.round(
          (event.loaded * 100) / event.total
        );
      
        //  console.log(store.state.loadingPatternProgress.status);
     store.commit("SetLoadingPatternProgress", {
          status : true,
          progress :`As imagens estão ${progress}% carregadas...`,
          total : (event.loaded / 1024 / 1024).toFixed(2), 
          loading : (event.total / 1024 / 1024).toFixed(2)
        }); // insere o loading

      },
    })
    .then((response) => {

      store.commit("SetLoadingPatternProgress", {
        status : false,
        progress : 0, 
        total : 0, 
        loading : 0,
      });  

    }).catch((err) => {

      console.error(
        `Houve um problema ao realizar o upload da imagem no servidor `
      );

      store.commit("SetLoadingPatternProgress", {
        status : false,
        progress : 0, 
        total : 0, 
        loading : 0,
      });  
      
    });
 
    
    return rrimImages;

  } catch (e) {
    
    store.commit("SetLoadingPatternProgress", {
      status : false,
      progress : 0, 
      total : 0, 
      loading : 0,
    }); 

    console.log(e.message);
  }
}

export { PostImagesRRIM };
